import { Controller } from '@hotwired/stimulus'
import Pickr from '@simonwep/pickr'
import '@simonwep/pickr/dist/themes/nano.min.css'

// Pickr-Color-Picker für SimpleForm/Slim-Forms — Drop-In-Ersatz für den nativen
// <input type="color">. Hält den darunterliegenden Input als Source-of-Truth für
// den Form-Submit; Pickr bedient nur das Picker-UI und schreibt Hex-Werte zurück.
//
// Markup-Vertrag:
//   <div data-controller="coworkr-color-picker"
//        data-coworkr-color-picker-default-value="#222222">
//     <div data-coworkr-color-picker-target="swatch"></div>
//     <input  data-coworkr-color-picker-target="input" value="#ABC123">
//   </div>
export default class extends Controller {
  static targets = ['input', 'swatch']
  static values  = { default: { type: String, default: '#222222' } }

  connect() {
    if (!this.hasInputTarget || !this.hasSwatchTarget) return

    const initial = this.normalize(this.inputTarget.value) || this.defaultValue

    this.pickr = Pickr.create({
      el: this.swatchTarget,
      theme: 'nano',
      default: initial,
      defaultRepresentation: 'HEX',
      comparison: false,
      components: {
        preview: true,
        opacity: false,
        hue: true,
        interaction: {
          rgba: false,
          hex: false,
          cmyk: false,
          input: false,
          save: true,
        },
      },
      i18n: { 'btn:save': 'Übernehmen' },
    })

    this.pickr.on('change', (color) => {
      this.inputTarget.value = color.toHEXA().toString()
      this.inputTarget.dispatchEvent(new Event('input', { bubbles: true }))
    })
    this.pickr.on('save', (color) => {
      if (color) this.inputTarget.value = color.toHEXA().toString()
      this.pickr.hide()
    })

    // Wenn das Hex-Feld manuell editiert wird, den Swatch nachziehen.
    this._syncFromInput = () => {
      const v = this.normalize(this.inputTarget.value)
      if (v) this.pickr.setColor(v, true)
    }
    this.inputTarget.addEventListener('input', this._syncFromInput)
  }

  disconnect() {
    if (this._syncFromInput) {
      this.inputTarget.removeEventListener('input', this._syncFromInput)
      this._syncFromInput = null
    }
    this.pickr?.destroyAndRemove()
    this.pickr = null
  }

  normalize(value) {
    const v = String(value || '').trim()
    if (/^#[0-9a-fA-F]{6}$/.test(v)) return v
    if (/^[0-9a-fA-F]{6}$/.test(v)) return `#${v}`
    return ''
  }
}
